import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/complexRacersList.css';

import {getFormattedCurrency, getText} from '../../../../../../helpers/localization';
import {ASSETS_URL} from '../../../../../../constants/endpoints';
import {hasEventTypeRacerNumberUI, sortRacersByOdd} from '../../../../modules/racing/helpers/racersHelper';
import {getGameTitle} from '../../../../../../helpers/eventHelpers';
import {getChipValue, getClosestChipByValue} from '../../../../../../constants/chips';
import {
    compareBetRacers,
    createBet,
    generateBoxForecastPossibilities,
    generateBoxTricastPossibilities,
    generateForecastPossibilities,
    generateTricastPossibilities,
    getOpenBet,
    marketHasOpenBet
} from '../../../../helpers/betHelpers';
import {incrementBetValue} from '../../../../actions/openBetsActions';
import CheckCircle from '../../../../sharedComponents/components/checkCircle';
import {
    addMultiBetSelection,
    removeMultiBetSelection,
    toogleBoxBets
} from '../../../../modules/racing/actions/raceCardActions';
import {EXACTA, EXACTA_BOX, TRIFECTA, TRIFECTA_BOX} from '../../../../modules/racing/constants/identifiers';

const mapStateToProps = (state, ownProps) => {
    return {
        events: state.vpp.events,
        selectedEventId: state.vpp.selectedEventId,
        selectedEventIndex: state.vpp.selectedEventIndex,
        selectedRacingBetType: state.vpp.selectedRacingBetType,
        openBetsList: state.vpp.openBetsList,
        selectedChip: state.vpp.selectedChip,
        openBetsHistory: state.vpp.openBetsHistory,
        isSimpleBetsSelected: state.vpp.isSimpleBetsSelected,
        selectedEventMultiBetList: state.vpp.selectedEventMultiBetList,
        isBoxBetsButtonToggled: state.vpp.isBoxBetsButtonToggled
    };
};

class ComplexRacersList extends Component {
    constructor(props) {
        super(props);

        let store = props.store;
        let storeData = store.getState();

        this.state = {
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip,
            openBetsHistory: storeData.vpp.openBetsHistory,
            isSimpleBetsSelected: storeData.vpp.isSimpleBetsSelected,
            selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList,
            isBoxBetsButtonToggled: storeData.vpp.isBoxBetsButtonToggled
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        this.setState({
            events: storeData.vpp.events,
            selectedEventId: storeData.vpp.selectedEventId,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            selectedRacingBetType: storeData.vpp.selectedRacingBetType,
            openBetsList: storeData.vpp.openBetsList,
            selectedChip: storeData.vpp.selectedChip,
            openBetsHistory: storeData.vpp.openBetsHistory,
            isSimpleBetsSelected: storeData.vpp.isSimpleBetsSelected,
            selectedEventMultiBetList: storeData.vpp.selectedEventMultiBetList,
            isBoxBetsButtonToggled: storeData.vpp.isBoxBetsButtonToggled
        });
    }

    _click(racerNumber) {
        let isSelected = this.state.selectedEventMultiBetList.find((mb) => mb === racerNumber);
        this.props.store.dispatch(
            isSelected
                ? removeMultiBetSelection(racerNumber)
                : addMultiBetSelection(racerNumber, this.state.selectedEventMultiBetList));
    }

    _createBetChipsUI(selectedGame, selectedEvent, market, racers) {
        let betChipsUI = [];
        let totalStake;
        if (this.state.openBetsHistory && this.state.openBetsHistory.length) {
            let currBetHistory = this.state.openBetsHistory.filter((bet) => bet.game.channel === selectedGame.channel && bet.event.eventId === selectedEvent.eventId && bet.market.code === market.code && compareBetRacers(bet.racers, racers));

            if (currBetHistory && currBetHistory.length) {
                if (currBetHistory.length === 1) {
                    totalStake = currBetHistory[0].value;
                } else {
                    totalStake = currBetHistory.reduce((acc, betHist) => +acc + betHist.value, 0);
                }
            } else {
                return '';
            }

            betChipsUI = (<div id={'betChips_' + market.id} className={style.betChipsContainer}>
                <img key={'CHIP_STAKE'} className={style.betChips}
                     src={`${ASSETS_URL + getClosestChipByValue(totalStake).assetChip}`} alt={'chips'}/>
                <div className={style.chipValueOuter}>
                    <div
                        className={style.chipValueInner}>{getFormattedCurrency(this.props.store, totalStake / 100, 0)}</div>
                </div>
            </div>);
        }
        return betChipsUI;
    }

    _createExactaUI() {
        let storeData = this.props.store.getState().vpp;
        let selectedGame = storeData.games[storeData.selectedGameIndex];
        let selectedEvent = storeData.events[storeData.selectedEventIndex];
        let selectedChip = this.state.selectedChip;
        let incrementValue = getChipValue(selectedChip);
        let market = {
            code: this.state.isBoxBetsButtonToggled
                ? EXACTA_BOX.code
                : EXACTA.code
        };
        let ret = null;

        if (storeData.events[storeData.selectedEventIndex].priceList && storeData.events[storeData.selectedEventIndex].priceList.forecast) {

            let betPossibilities = this.state.isBoxBetsButtonToggled
                ? generateBoxForecastPossibilities(this.state.selectedEventMultiBetList)
                : generateForecastPossibilities(this.state.selectedEventMultiBetList);

            for (var i = 0; i < betPossibilities.length; i++) {
                betPossibilities[i].racers = [
                    this._getRacerByNum(betPossibilities[i].first),
                    this._getRacerByNum(betPossibilities[i].second)
                ];
                betPossibilities[i].odd = this.state.isBoxBetsButtonToggled
                    ? storeData.events[storeData.selectedEventIndex].priceList.reverseForecast[`${betPossibilities[i].first}-${betPossibilities[i].second}`]
                    : storeData.events[storeData.selectedEventIndex].priceList.forecast[`${betPossibilities[i].first}-${betPossibilities[i].second}`];
                betPossibilities[i].market = {
                    id: `${market.code}_${betPossibilities[i].first}-${betPossibilities[i].second}`,
                    code: market.code,
                    odds: betPossibilities[i].odd
                };
            }

            let betPossibilitiesOrdered = betPossibilities.sort(sortRacersByOdd);

            ret = betPossibilitiesOrdered.map((bt, index) => {
                let oddsText;
                let isSelected = marketHasOpenBet(selectedGame, selectedEvent, bt.market, bt.racers, this.state.openBetsList);
                if (isSelected) {
                    oddsText = getFormattedCurrency(this.props.store, (bt.odd * getOpenBet(selectedGame, selectedEvent, bt.market, bt.racers, this.state.openBetsList).stake / 100).toFixed(2));
                } else {
                    oddsText = getFormattedCurrency(this.props.store, (bt.odd * incrementValue / 100).toFixed(2));
                }
                let betChipsUI = this._createBetChipsUI(selectedGame, selectedEvent, bt.market, bt.racers);
                return (<div id={'exacta_' + index} className={`${style.button} ${isSelected
                    ? style.selected
                    : ''}`} key={'exacta_' + index}
                             onClick={() => this.props.store.dispatch(incrementBetValue(createBet(selectedGame, selectedEvent, bt.market, bt.racers, incrementValue), incrementValue, storeData.openBetsList))}>
                    <div className={style.complexBetRacersContainer}>
                        {this._createRacersImagesUI(selectedEvent.eventType, bt.racers)}
                    </div>
                    <div className={style.oddsText} id={`${bt.first}_${bt.second}`}>{oddsText}</div>
                    {betChipsUI}
                </div>);
            });

        }
        return ret;
    }

    _createTrifectaUI() {
        let storeData = this.props.store.getState().vpp;
        let selectedGame = storeData.games[storeData.selectedGameIndex];
        let selectedEvent = storeData.events[storeData.selectedEventIndex];
        let selectedChip = this.state.selectedChip;
        let incrementValue = getChipValue(selectedChip);
        let market = {
            code: this.state.isBoxBetsButtonToggled
                ? TRIFECTA_BOX.code
                : TRIFECTA.code
        };
        let ret = null;

        if (storeData.events[storeData.selectedEventIndex].priceList && storeData.events[storeData.selectedEventIndex].priceList.forecast) {

            let betPossibilities = this.state.isBoxBetsButtonToggled
                ? generateBoxTricastPossibilities(this.state.selectedEventMultiBetList)
                : generateTricastPossibilities(this.state.selectedEventMultiBetList);

            for (var i = 0; i < betPossibilities.length; i++) {
                betPossibilities[i].racers = [
                    this._getRacerByNum(betPossibilities[i].first),
                    this._getRacerByNum(betPossibilities[i].second),
                    this._getRacerByNum(betPossibilities[i].third)
                ];
                betPossibilities[i].odd = this.state.isBoxBetsButtonToggled
                    ? storeData.events[storeData.selectedEventIndex].priceList.reverseTricast[`${betPossibilities[i].first}-${betPossibilities[i].second}-${betPossibilities[i].third}`]
                    : storeData.events[storeData.selectedEventIndex].priceList.tricast[`${betPossibilities[i].first}-${betPossibilities[i].second}-${betPossibilities[i].third}`];
                betPossibilities[i].market = {
                    id: `${market.code}_${betPossibilities[i].first}-${betPossibilities[i].second}-${betPossibilities[i].third}`,
                    code: market.code,
                    odds: betPossibilities[i].odd
                };
            }

            let betPossibilitiesOrdered = betPossibilities.sort(sortRacersByOdd);

            ret = betPossibilitiesOrdered.map((bt, index) => {
                let oddsText;
                let isSelected = marketHasOpenBet(selectedGame, selectedEvent, bt.market, bt.racers, this.state.openBetsList);
                if (isSelected) {
                    oddsText = getFormattedCurrency(this.props.store, (bt.odd * getOpenBet(selectedGame, selectedEvent, bt.market, bt.racers, this.state.openBetsList).stake / 100).toFixed(2));
                } else {
                    oddsText = getFormattedCurrency(this.props.store, (bt.odd * incrementValue / 100).toFixed(2));
                }
                let betChipsUI = this._createBetChipsUI(selectedGame, selectedEvent, bt.market, bt.racers);
                return (<div id={'exacta_' + index} className={`${style.button} ${isSelected
                    ? style.selected
                    : ''}`} key={'exacta_' + index}
                             onClick={() => this.props.store.dispatch(incrementBetValue(createBet(selectedGame, selectedEvent, bt.market, bt.racers, incrementValue), incrementValue, storeData.openBetsList))}>
                    <div className={style.complexBetRacersContainer}>
                        {this._createRacersImagesUI(selectedEvent.eventType, bt.racers)}
                    </div>
                    <div className={style.oddsText} id={`${bt.first}_${bt.second}_${bt.third}`}>{oddsText}</div>
                    {betChipsUI}
                </div>);
            });

        }
        return ret;
    }

    _getRacerByNum(num) {
        return this.state.events[this.state.selectedEventIndex].racers.find(racer => racer.num.toString() === num.toString());
    }

    _createRacersImagesUI(eventType, racers) {
        let storeData = this.props.store.getState().vpp;
        let ret = racers.map((racer, index) => {
            return (<div key={index} className={style.complexBetsRacerIconContainer}>
                {
                    hasEventTypeRacerNumberUI(eventType)
                        ? (<div className={style.racerNumber}>{racer.num}</div>)
                        : ''
                }
                <img
                    src={`${ASSETS_URL}${storeData.games[storeData.selectedGameIndex].assetsPath}/silks/silk${racer.num}.png`}
                    className={style.racerIconImage} alt={`icon${racer.num}`}/>
            </div>);
        })
        return ret;
    }

    _createBoxUI() {
        return (<CheckCircle htmlId={'boxBetsToggle'} style={style.checkContainer}
                             isChecked={this.state.isBoxBetsButtonToggled} isEnabled={true}
                             callback={() => this.props.store.dispatch(toogleBoxBets())}/>);
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = this.state.events[storeData.vpp.selectedEventIndex];
        let racersListUI;
        racersListUI = this.state.events[this.state.selectedEventIndex].racers.map((racer, index) => {
            let isSelected = this.state.selectedEventMultiBetList.find((mb) => mb === racer.num);
            return (<div className={style.racerContainer} key={index}>
                <div className={style.racerShirtAndName}>
                    <div id={'simple_bet_racer_silk_' + racer.num} className={style.racerIconContainer}>
                        {
                            hasEventTypeRacerNumberUI(selectedEvent.eventType)
                                ? (<div id={'slider_racer_number_' + racer.num}
                                        className={style.racerNumber}>{racer.num}</div>)
                                : ''
                        }
                        <img
                            src={`${ASSETS_URL}${storeData.vpp.games[storeData.vpp.selectedGameIndex].assetsPath}/silks/silk${Number(racer.silk) + 1}.png`}
                            className={style.racerIcon} alt={`icon${racer.silk}`}/>
                    </div>
                    <div className={style.racerNameContainer}>
                        <div className={style.racerName}>{racer.name}</div>
                    </div>
                </div>
                <CheckCircle htmlId={racer.num + '_checkCircle'} style={style.checkContainer} isChecked={isSelected}
                             isEnabled={true} callback={() => this._click(racer.num)}/>
            </div>);
        });

        let mainContainerStyle = !this.state.isSimpleBetsSelected
            ? style.visible
            : style.hidden;

        return (<div className={`${style.complexRacersListMainContainer} ${mainContainerStyle}`}>
            <div className={style.racersContainer}>
                <div id={'eventTitle'}
                     className={style.eventTitle}>{getGameTitle(this.state.events[this.state.selectedEventIndex])}</div>
                {racersListUI}
            </div>
            <div className={style.halfContainer}>
                <div className={style.topBar}>
                    <div className={style.exactaTableHeader}>{getText('EXACTA', this.props.store)}</div>
                    <div className={style.trifectaTableHeader}>{getText('TRIFECTA', this.props.store)}</div>
                </div>
                <div className={style.content}>
                    <div className={style.exactasContent}>{this._createExactaUI()}</div>
                    <div className={style.trifectasContent}>{this._createTrifectaUI()}</div>
                </div>
                <div className={style.bottomBarPadding}/>
                <div className={style.bottomBar}>
                    <div className={style.boxButtonTextContainer}>{getText('BOX', this.props.store)}</div>
                    {this._createBoxUI()}
                </div>
            </div>
        </div>);
    }
}

export default connect(mapStateToProps)(ComplexRacersList);


// WEBPACK FOOTER //
// ./src/ui-modules/simplified/desktop/modules/racing/containers/complexRacersList.js